// Utility to compute delivery-lateness state used to paint order rows.
// Rules (business): 
//   - Ciudad orders: RED after 1 day past fecha_entrega_hasta if not yet "entregado".
//   - Departamento (or expreso): YELLOW after 3 days past fecha_entrega_hasta if not yet "entregado".
// Ignores canceled orders.
export function atrasoInfo(order, now = new Date()) {
  if (!order) return { atrasado: false, dias: 0, color: null };
  if (order.estado === "cancelado") return { atrasado: false, dias: 0, color: null };
  // Excluir pedidos ya archivados (cerrados) del cálculo de atraso
  if (order.cierre_id) return { atrasado: false, dias: 0, color: null };
  // Excluir pedidos entregados
  if ((order.estado_entrega || "") === "entregado") return { atrasado: false, dias: 0, color: null };
  // Excluir pedidos 100% facturados (aunque no se hayan marcado como entregado formalmente)
  const totalPed = Number(order.total || 0);
  const totalFact = Number(order.monto_facturado_acum || 0);
  if (totalPed > 0 && totalFact >= totalPed - 0.01 && (order.estado === "facturado" || order.estado === "pagado")) {
    return { atrasado: false, dias: 0, color: null };
  }
  const ref = order.fecha_entrega_hasta || order.fecha_entrega;
  if (!ref) return { atrasado: false, dias: 0, color: null };
  const refDate = new Date(`${ref}T23:59:59`);
  if (isNaN(refDate.getTime())) return { atrasado: false, dias: 0, color: null };
  const diffMs = now.getTime() - refDate.getTime();
  const dias = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (order.envio_tipo === "ciudad") {
    if (dias >= 1) return { atrasado: true, dias, color: "rojo" };
  } else {
    if (dias >= 3) return { atrasado: true, dias, color: "amarillo" };
  }
  return { atrasado: false, dias, color: null };
}

export function rowClassForAtraso(order) {
  const info = atrasoInfo(order);
  if (!info.atrasado) return "";
  // R33: rojo intenso para pedidos atrasados (mismo color que la badge "Atrasado")
  if (info.color === "rojo") return "bg-red-500 hover:bg-red-600 text-white";
  if (info.color === "amarillo") return "bg-yellow-200 hover:bg-yellow-300";
  return "";
}
